import { type JobType, type ShiftNameType } from "@src/appV2/redesign/PlacementCandidate/types";

import { type PlacementForComputedPay } from "../../../lib/usePayTransparencyRates";

interface ShiftTime {
  startTime?: string;
  endTime?: string;
}

export function getShiftTimesForType(
  placement: PlacementForComputedPay,
  jobType: JobType,
  shiftType: ShiftNameType
): ShiftTime[] {
  const shiftTimes: ShiftTime[] = [];

  placement.jobShifts.forEach((jobShift) => {
    if (jobShift.jobType === jobType && jobShift.shiftTypesWithTime) {
      jobShift.shiftTypesWithTime.forEach((shiftTypeWithTime) => {
        if (
          shiftTypeWithTime.type.toLowerCase() === shiftType.toLowerCase() &&
          (shiftTypeWithTime.startTime ?? shiftTypeWithTime.endTime)
        ) {
          shiftTimes.push({
            startTime: shiftTypeWithTime.startTime,
            endTime: shiftTypeWithTime.endTime,
          });
        }
      });
    }
  });

  return shiftTimes;
}
